import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
// import { StaticImage } from "gatsby-plugin-image"
import Link from "../../../basics/Link"
// import { ArrowLink } from "../../../basics/Link"
import { router } from "../../../../utility/router"
import { PageContext } from "../../Page"

const MenuInsights = ({ closeMenuFunction = () => { } }) => {
  const context = useContext(PageContext)
  const [t] = useTranslation("layout")

  return <>
    <div className="h-full p-5 border-r">
      <h5 className="text-blue-10">{t('header.insightsMenu.title')}</h5>
      <div className="text-small text-midnight-20 mt-1">{t('header.insightsMenu.description')}</div>
    </div>

    <div className="h-full px-5 pt-5 pb-3.5 col-span-2">
      <Link to={router('insights.articles', context.folder)} className="text-xs pb-1.5 block" onClick={() => closeMenuFunction()}>
        {t('header.insightsMenu.articles')}
      </Link>
      <Link to={router('insights.whitepaper', context.folder)} className="text-xs py-1.5 block" onClick={() => closeMenuFunction()}>
        {t('header.insightsMenu.whitepaper')}
      </Link>
      {/* <Link to={router('insights.video', context.folder)} className="text-xs py-1.5 block">{t('header.insightsMenu.video')}</Link> */}
      {/* <Link to={router('insights.podcast', context.folder)} className="text-xs py-1.5 block">{t('header.insightsMenu.podcast')}</Link> */}
      {/* <Link to={router('insights.webinar', context.folder)} className="text-xs py-1.5 block">{t('header.insightsMenu.webinar')}</Link> */}
    </div>

    {/* <div className="h-full p-5 bg-midnight-60">
      <StaticImage src="../../../../assets/images/header/header-insights.png" alt="insight" />
      <div className="mt-3 text-xs">
        {t('header.insightsMenu.rightTitle')}
      </div>
      <div className="mt-1 text-small">
        {t('header.insightsMenu.rightDescription')}
      </div>
      <ArrowLink to={router('insights.articles', context.folder)} className="py-1">{t('header.insightsMenu.rightButton')}</ArrowLink>
    </div> */}
  </>
}

export default MenuInsights